import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 3.358a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-2.75 1.25a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0m0 5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75zm1.5.75v11h2.5v-11zm8 4c0-.523.338-1.539 1.15-2.434.783-.864 1.964-1.566 3.6-1.566s2.817.702 3.6 1.566c.812.895 1.15 1.91 1.15 2.434v7h-2v-6.25a3.26 3.26 0 0 0-.692-1.963c-.455-.58-1.158-1.037-2.058-1.037-.842 0-1.553.345-2.041.922-.478.565-.709 1.308-.709 2.078v6.25h-2v-7m11 7.75h-.75za.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75H18h-.75v-7c0-.33-.13-.73-.371-1.036-.232-.296-.53-.464-.879-.464-.408 0-.697.155-.896.39-.21.249-.354.63-.354 1.11v7H14h.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75h.75-.75v-7.75c0-.976.537-2.336 1.538-3.44 1.029-1.136 2.598-2.06 4.712-2.06s3.683.924 4.712 2.06c1.001 1.104 1.538 2.464 1.538 3.44v7.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }